import { DashboardStore } from '.';
import { RootState } from '../..';

export const selectDashboard = (state: RootState): DashboardStore => state.dashboard;
